import {Injectable} from '@angular/core';
import {Subject} from 'rxjs/Subject';
import 'rxjs/add/operator/share';

@Injectable()
export class SpinnerService {
  public status: Subject<boolean> = new Subject();
  private _active: number = 0;

  private changeActive(delta: number) {
    this._active += delta; // should we care for thread safety?
    this.status.next(this._active > 0);
  }

  public start(): void {
    this.changeActive(1);
  }

  public stop(): void {
    this.changeActive(-1);
  }
}



// WEBPACK FOOTER //
// ./src/app/Services/spinner.ts